import { render } from "./FaqComp.vue?vue&type=template&id=938f4e44&ts=true"
import script from "./FaqComp.vue?vue&type=script&lang=ts"
export * from "./FaqComp.vue?vue&type=script&lang=ts"

import "./FaqComp.vue?vue&type=style&index=0&id=938f4e44&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__